import { connect, Dispatch } from 'react-redux';

import Header, { HeaderProps } from '../components/Header';
import { getBranding } from '../reducers';
import { StoreState } from '../types';
import { logout } from '../actions';

export default connect(mapStateToProps, mapDispatchToProps)(Header);

function mapStateToProps(state: StoreState): Pick<HeaderProps, 'branding'> {
  return {
    branding: getBranding(state)
  };
}

function mapDispatchToProps(
  dispatch: Dispatch<StoreState>
): Pick<HeaderProps, 'logout'> {
  return {
    logout() {
      dispatch(logout());
    }
  };
}



// WEBPACK FOOTER //
// ./src/containers/Header.tsx